/**
 * Extract a Backlog issue key (e.g. "MIG-123") from a Backlog issue URL.
 * Returns null for non-matching inputs.
 *
 * Accepted shapes (Backlog's canonical URL format):
 *   https://{space}.backlog.com/view/MIG-123
 *   https://{space}.backlog.jp/view/MIG-123
 *   https://{space}.backlog.com/view/MIG-123#comment-456
 *   https://{space}.backlog.com/view/MIG-123?foo=bar
 */
export function extractIssueKey(url: string): string | null {
  const trimmed = url.trim();
  if (!trimmed) return null;
  const match = trimmed.match(/\/view\/([A-Z][A-Z0-9_]*-\d+)/);
  return match?.[1] ?? null;
}

export function extractIssueKeys(urls: readonly string[]): string[] {
  const keys = new Set<string>();
  for (const url of urls) {
    const key = extractIssueKey(url);
    if (key) keys.add(key);
  }
  return [...keys];
}

/**
 * Build a Backlog issue page URL from the project's space URL and an
 * issue key. Returns null when the space URL is missing so callers can
 * render a non-link fallback.
 */
export function buildBacklogIssueUrl(
  spaceUrl: string | null | undefined,
  issueKey: string,
): string | null {
  if (!spaceUrl) return null;
  const base = spaceUrl.replace(/\/+$/, '');
  return `${base}/view/${issueKey}`;
}
